(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaBuOwnerAddBIAResponsibilitiesController', Controller);

    Controller.$inject = ['$scope', '$q', '$state', '$timeout', 'govNotificationDelay',  'biaProfileService', 'biaResponsibilityService', 'bcmResponsibilityService'];

    function Controller($scope, $q, $state, $timeout, govNotificationDelay, biaProfileService, biaResponsibilityService, bcmResponsibilityService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {

            // Active lang, might be changed in different places, initializes in english
            langAttr: null, // Default set in init
            lang: 'EN'
        };

        // Get Possible responsibilities
        biaProfileService
            .getPossibleResponsibilitiesForBUOwner($scope.boxContext.BIAProfile.BIAProfileID,
                                                   $scope.boxModel.BusinessUnit.BusinessUnitID)
            .then(function (availableResponsibilities) {
                $scope.availableResponsibilities = availableResponsibilities;
            });

        // Add BCM Responsibility
        $scope.addBCMResponsibility = function () {
            $scope.availableResponsibilities.unshift({ BCMToAdd: true });
            $scope.ctrlCtxt.isAddingBCM = true;
        }

        // cancel Add BCM Responsibility
        $scope.cancelAddBCMResponsibility = function () {
            _.remove($scope.availableResponsibilities, { BCMToAdd: true });
            $scope.ctrlCtxt.isAddingBCM = false;
        };

        // Select Responsibility
        $scope.selectResponsibility = function (resp) {
            if (_.isUndefined($scope.responsibilitiesToAdd)) $scope.responsibilitiesToAdd = [];

            // PRC Responsibility
            if (!_.isUndefined(resp.ResponsibilityID)) {
                resp.PRCResponsibilityID = resp.ResponsibilityID;
                $scope.responsibilitiesToAdd.push(resp);
                _.remove($scope.availableResponsibilities, { ResponsibilityID: resp.PRCResponsibilityID });
            }

            // BCM Responsibility
            if (resp.BCMToAdd) {
                resp.BusinessUnitID = $scope.boxModel.BusinessUnit.BusinessUnitID;
                $scope.responsibilitiesToAdd.unshift(resp);
                _.remove($scope.availableResponsibilities, { BCMToAdd: true });
                $scope.ctrlCtxt.isAddingBCM = false;
            }
        };

        // Is Save Changes Disabled?
        $scope.isSaveChangesDisabled = function (form) {
            if (_.isUndefined(form)) return;
            if (form.$invalid) return true;

            return _.size($scope.responsibilitiesToAdd) === 0;
        };

        // Save Changes
        $scope.saveChanges = function () {

            if ($scope.isSaveChangesDisabled($scope.form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                    $scope.ctrlCtxt.showSubmitError = false;
                }, govNotificationDelay);

                return;
            }

            var promiseChain = $q.when();

            // Chain Responsibility Creations
            _.each($scope.responsibilitiesToAdd, function (respToAdd) {

                if (!_.isUndefined(respToAdd.PRCResponsibilityID)) {
                    // PRC Responsibility
                    respToAdd.BIABUOwnerID = $scope.boxModel.BIABUOwnerID;
                    promiseChain = promiseChain
                        .then(function () {
                            return biaResponsibilityService
                                .createBIAResponsibility($scope.boxContext.BIAProfile.BIAProfileID, respToAdd);
                        });
                } else if (respToAdd.BCMToAdd) {
                    // BCM Responsibility
                    promiseChain = promiseChain
                        .then(function () {
                            return bcmResponsibilityService
                                .createBCMResponsibility($scope.boxContext.BIAProfile.BIAProfileID, respToAdd)
                                .then(function (createdBCMResp) {
                                    createdBCMResp.BIAProfileID = $scope.boxContext.BIAProfile.BIAProfileID;
                                    createdBCMResp.BIABUOwnerID = $scope.boxModel.BIABUOwnerID;
                                    return biaResponsibilityService
                                        .createBIAResponsibility(createdBCMResp.BIAProfileID, createdBCMResp);
                                });
                        });
                }
            });
            promiseChain.then(function () {
                $state.go('^', {}, { reload: true });
            });
        };
    }
})();